import {Injectable} from '@angular/core';
import {ProjectService} from './project.service';
import {Observable, throwError} from 'rxjs';
import {catchError, map, shareReplay, tap} from 'rxjs/operators';
import {AppointmentProjectTypes} from '../models/appointment-project-types.enum';

@Injectable({
  providedIn: 'root'
})
export class WebsiteConfigService {

  constructor(private _projectService: ProjectService) {
  }

  formatConfig(configs: any[]): any {
    const retObject = {};
    configs.forEach(e => {
      if (e.status !== '1') { return; }
      try {
        retObject[e.type] = e.type !== 'fbpixel' ? JSON.parse(e.content) : e.content;
      } catch (error) {
        retObject[e.type] = e.content;
      }
    });
    return retObject;
  }

  hasAppointments(): Observable<boolean> {
    return this._projectService.getProjectType().pipe(
      map(e => Object.values(AppointmentProjectTypes).includes(e)),
      shareReplay({bufferSize: 1, refCount: true}),
      catchError(err => throwError(err))
    );
  }

  getAnalytics(): Observable<string> {
    return this.getAll().pipe(
      map(e => e?.analytics),
      shareReplay({bufferSize: 1, refCount: true}),
      catchError(err => throwError(err))
    );
  }

  getFbPixel(): Observable<string> {
    return this.getAll().pipe(
      map(e => e?.fbpixel),
      shareReplay({bufferSize: 1, refCount: true}),
      catchError(err => throwError(err))
    );
  }

  getTagManager(): Observable<string> {
    return this.getAll().pipe(
      map(e => e?.tagmanager),
      shareReplay({bufferSize: 1, refCount: true}),
      catchError(err => throwError(err))
    );
  }

  getCustomJsHtml(): Observable<string> {
    return this.getAll().pipe(
      map(e => e?.customjshtml),
      shareReplay({bufferSize: 1, refCount: true}),
      catchError(err => throwError(err))
    );
  }

  getExtraFooter(): Observable<string> {
    return this.getAll().pipe(
      map(e => e?.extrafooter),
      shareReplay({bufferSize: 1, refCount: true}),
      catchError(err => throwError(err))
    );
  }

  getLinks(): Observable<any> {
    return this.getAll().pipe(
      map(e => e?.links),
      shareReplay({bufferSize: 1, refCount: true}),
      catchError(err => throwError(err))
    );
  }

  getAll(): Observable<any> {
    return this._projectService.getWebsiteConfig().pipe(
      map(e => e ? this.formatConfig(e) : undefined),
      shareReplay({bufferSize: 1, refCount: true}),
      catchError(err => throwError(err))
    );
  }
}
